import {createAuthClient} from 'better-auth/react'
import {inferAdditionalFields} from 'better-auth/client/plugins'
import {passkeyClient} from '@better-auth/passkey/client'

const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3000'

export const authClient = createAuthClient({
  baseURL,
  // Send/receive the session cookie on cross-origin requests (front :5173 → api :3000).
  fetchOptions: {credentials: 'include'},
  plugins: [
    passkeyClient(),
    // Mirror the server-side additional fields so signUp accepts them and the
    // session user is typed with firstName / lastName.
    inferAdditionalFields({
      user: {
        firstName: {type: 'string'},
        lastName: {type: 'string'}
      }
    })
  ]
})

export const {signIn, signUp, signOut, useSession} = authClient
